"use client";
import * as SwitchPrimitive from "@radix-ui/react-switch";
import { type VariantProps, cva } from "class-variance-authority";
import { twMerge } from "tailwind-merge";

const switchVariants = cva(
  "rounded-full inline-flex items-center transition-colors focus-visible:outline-hidden data-disabled:bg-grey-100 data-[state=checked]:bg-primary-600 data-[state=unchecked]:bg-grey-100 data-[state=unchecked]:not(:disabled):hover:bg-grey-200 data-[state=checked]:not(:disabled):hover:bg-primary-700 disabled:cursor-not-allowed focus-visible:ring-4 ring-primary-200/70",
  {
    variants: {
      size: {
        xs: "w-7.5 h-4.5 px-0.5",
        sm: "w-9 h-5 px-0.5",
        md: "h-6 w-11 px-0.5",
      },
    },
    defaultVariants: {
      size: "sm",
    },
  },
);

const switchThumbVariants = cva(
  "size-4 data-disabled:bg-grey-50 pointer-events-none block rounded-full bg-white shadow-sm transition-transform data-[state=unchecked]:translate-x-0",
  {
    variants: {
      size: {
        xs: "w-3.5 h-3.5 data-[state=checked]:translate-x-3",
        sm: "w-4 h-4 data-[state=checked]:translate-x-4",
        md: "w-5 h-5 data-[state=checked]:translate-x-5",
      },
    },
    defaultVariants: {
      size: "sm",
    },
  },
);

const Switch = ({
  className,
  size,
  ref,
  ...props
}: React.ComponentProps<typeof SwitchPrimitive.Root> &
  VariantProps<typeof switchVariants>) => (
  <SwitchPrimitive.Root
    className={twMerge(switchVariants({ size, className }))}
    {...props}
    ref={ref}
  >
    <SwitchPrimitive.Thumb className={twMerge(switchThumbVariants({ size }))} />
  </SwitchPrimitive.Root>
);

export { Switch };
